import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M11.59 6.41h-2.2l-.48 1.67H7.76L9.7 1.72h1.55l2.05 6.36h-1.18Zm-1.94-.92h1.67l-.85-3ZM6.05 3.89a1.9 1.9 0 0 1 .64.8 3 3 0 0 1 .23 1.21V6a2.42 2.42 0 0 1-.25 1.1 2 2 0 0 1-.73.82 1.74 1.74 0 0 1-1 .29 1.69 1.69 0 0 1-1.27-.52l-.1.41H2.7V1.72h1.13v2.39a1.67 1.67 0 0 1 1.25-.5 1.75 1.75 0 0 1 .97.28Zm-.26 2c0-.93-.31-1.39-.94-1.39a1.27 1.27 0 0 0-.58.13 1.33 1.33 0 0 0-.44.37v2a1.21 1.21 0 0 0 .93.4.87.87 0 0 0 .75-.4 1.66 1.66 0 0 0 .28-1.05Z';
const draw24px =
  'M17.39,9.61h-3.3l-.72,2.51H11.64l2.91-9.54h2.33L20,12.12H18.17ZM14.47,8.23H17L15.71,3.78ZM9.07,5.84A2.63,2.63,0,0,1,10,7a4.43,4.43,0,0,1,.34,1.81V9A3.73,3.73,0,0,1,10,10.62a3.18,3.18,0,0,1-1.09,1.23,2.76,2.76,0,0,1-1.5.44,2.48,2.48,0,0,1-1.89-.79l-.15.62H4.05V2.58H5.74V6.17a2.49,2.49,0,0,1,1.88-.75A2.5,2.5,0,0,1,9.07,5.84Zm-.39,3c0-1.4-.46-2.1-1.4-2.1a1.92,1.92,0,0,0-.87.2,2,2,0,0,0-.67.58v2.95a1.85,1.85,0,0,0,1.39.6,1.36,1.36,0,0,0,1.14-.56A2.53,2.53,0,0,0,8.68,8.9ZM20,17.51h-12V15.07a.75.75,0,0,0-1.28-.53L3.47,17.73a.75.75,0,0,0,0,1.06L6.66,22a.77.77,0,0,0,.53.22.72.72,0,0,0,.29-.06.75.75,0,0,0,.46-.69V19H20a.75.75,0,0,0,0-1.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const TextOrientationHorizontalLeftIcon = forwardRef<
  SVGSVGElement,
  ComponentProps<typeof Icon>
>(
  generateRenderedIcon(icons, 'textOrientationHorizontalLeft'),
) as IconWithRender;

TextOrientationHorizontalLeftIcon.displayName =
  'TextOrientationHorizontalLeftIcon';
TextOrientationHorizontalLeftIcon.propTypes = Icon.propTypes;
TextOrientationHorizontalLeftIcon.renderIcon = (props) => (
  <TextOrientationHorizontalLeftIcon {...props} />
);
export default TextOrientationHorizontalLeftIcon;
